// Suppliers Vuex

import state from './countryStates.js'
import * as getters from './countryGetters.js'
import * as mutations from './countryMutations.js'
import * as actions from './countryActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
